import { SVGProps, Ref, forwardRef } from 'react';

export const MicFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 11c0 3.75 2.5 5 5 5s5-1.25 5-5V6c0-3.75-2.5-5-5-5S7 2.25 7 6zm-3.92 1c.578 5.183 4.189 7.204 8.02 7.47v1.73H6.945V23h10v-1.8H12.9v-1.73c3.83-.266 7.442-2.287 8.02-7.47h-1.813c-.268 2.044-1.088 3.329-2.072 4.148C15.772 17.201 13.982 17.7 12 17.7s-3.772-.5-5.035-1.552C5.98 15.328 5.16 14.044 4.893 12z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MicFilledSize24Glyph.displayName = 'MicFilledSize24Glyph';
